export default ({ store, from }) => {
  if (process.client) {
    if (from && from.name && from.name !== 'index' && from.name !== 'slug' && from.name !== 'cau-hoi-slug') {
      store.dispatch('setClassFilter', null)
      store.dispatch('setStatusFilter', 0)
    }
  }
}
